/**
 * @module ModulesLayer
 *
 * Responsible for loading all the modules from `componentConfig.modules`.
 * Uses []
 */
import React from 'react';
import { useSelector } from 'react-redux';
import DynamicComponent from '../dynamicComponents/DynamicComponent';
import { createSelector } from '@reduxjs/toolkit';

/**
 * Data Selector for modules
 *
 * @returns {Object} - Returns module configs from redux store.
 *
 * @description Select module configs from redux store.
 *
 * - Selects store data from redux store.
 * - Add additional properties to select from redux store here.
 *
 *
 *
 */
const selectModules = createSelector(
	[(state) => state?.componentConfig?.modules || {}],
	(modules) => modules,
);

/**
 * ModulesLayer component
 * @description ModulesLayer component is responsible for loading all the modules.
 * - Loads modules like getProductData and cartData.
 * @returns {JSX.Element}
 *
 */
const ModulesLayer = () => {
	const modules = useSelector(selectModules);

	return (
		<>
			{Object.keys(modules).map((item) => {
				const { remoteConfig, properties } = modules[item];
				return (
					<DynamicComponent
						key={item}
						remoteConfig={remoteConfig}
						{...properties}
					/>
				);
			})}
		</>
	);
};

export default ModulesLayer;
